import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Linkify from 'react-linkify';
export var MessageContent = function (_a) {
    var message = _a.message;
    var componentDecorator = function (href, text, key) { return (_jsx("a", { className: "linkify__text", rel: "noreferrer", href: href, target: "_blank", children: text }, key)); };
    return (_jsx(React.Fragment, { children: _jsx("div", { className: "post-comments-unit-cont", children: _jsxs("div", { children: [" ", _jsx(Linkify, { componentDecorator: componentDecorator, children: message }), " "] }) }) }));
};
